module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.4fed03f1.woff";